// FileUpload domain slice: the image/document attachment state for the composer's
// upload path. These fields originate inside useFileUpload, which publishes them into
// this slice directly (the provider does not effect-bridge them).
//
// Extracted from composerSlice: the composer's submit/error state and the upload
// artifact state are distinct domains that happened to share a slice. `combineSlices`
// merges every slice into one flat store, so selectors (`state.imageData`, …) are
// unchanged by the move — this is an ownership cut, not a state-shape change.
export const fileUploadSlice = (set) => ({
  imageData: null,
  setImageData: (value) => set({ imageData: value }),
  isLoading: false,
  setIsLoading: (value) => set({ isLoading: value }),
  documentFile: null,
  setDocumentFile: (value) => set({ documentFile: value }),
  isDocumentLoading: false,
  setIsDocumentLoading: (value) => set({ isDocumentLoading: value }),
});
